import React from 'react';
import DescribeMealVoiceContainer from './DescribeMealVoiceContainer';
import {
  TrackerExtractIngredientsConnectorApollo,
  withMobileAppMode,
} from '@front-activerse/common-components';
import { useLocation } from 'react-router-dom';
import TrackerNoAccess from '../NoAccess/TrackerNoAccess';

const DescribeMealVoicePage: React.FC<{ mobileAppMode: boolean; fromUserMeals?: boolean }> = ({
  mobileAppMode,
  fromUserMeals,
}) => {
  const location = useLocation();

  const aiAccess = sessionStorage.getItem('aiAccess');

  if (aiAccess === 'true' || mobileAppMode) {
    return (
      <TrackerExtractIngredientsConnectorApollo>
        {({ extractIngredients, cancelExtractIngredients }) => (
          <DescribeMealVoiceContainer
            extractIngredients={extractIngredients}
            cancelExtractIngredients={cancelExtractIngredients}
            fromUserMeals={fromUserMeals}
            key={location.key} // Force re-render
          />
        )}
      </TrackerExtractIngredientsConnectorApollo>
    );
  }
  return <TrackerNoAccess />;
};

export default withMobileAppMode(DescribeMealVoicePage);
